import {
  Box,
  Button,
  Card,
  Chip,
  CircularProgress,
  IconButton,
  InputAdornment,
  //   CircularProgress,
  //   Paper,
  //   Table,
  //   TableBody,
  //   TableCell,
  //   TableContainer,
  //   TableHead,
  //   TableRow,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import ViewStudent from '../Student/ViewStudent';
import { useDispatch } from 'react-redux';
import { getStudentCurrentMarksAndPayments } from '../../features/student/studentSlice';
import ReusableMUITable from '../UIElements/ReusableMUITable';
import { Cancel, CheckCircle } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
function StudentFullDetails() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [studentId, setStudentId] = useState(null);
  const [searchValue, setSearchValue] = useState('');
  const [paymentsAndMarks, setPaymentsAndMarks] = useState({});
  const getStudentCurrentDetails = async (id) => {
    setLoading(true);
    try {
      const response = await dispatch(
        getStudentCurrentMarksAndPayments(id),
      ).unwrap();
      setPaymentsAndMarks(response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <Box className='p-4'>
        <Box className='bg-blue-50 p-4 rounded-lg mb-4'>
          <Typography variant='h6' className='text-blue-700 font-bold'>
            Student Information
          </Typography>
          <Typography variant='body1' className='text-gray-600'>
            Search student id and get complete details here.
          </Typography>
        </Box>{' '}
        <Card className=' p-4 border-t max-w-5xl'>
          {' '}
          <div className='max-w-5xl pb-6 '>
            <Typography variant='h6' className='text-blue-600'>
              {' '}
              Student Information
            </Typography>
            <Card className=' mb-4 p-4 border rounded'>
              <Typography variant='body1' className='mb-2'>
                Enter Student Id and search for the payments history detials.
              </Typography>
              <div className='flex items-end'>
                <TextField
                  value={searchValue}
                  id='studentId'
                  className=' mr-10 mt-2 w-60'
                  size='small'
                  label='Student Id'
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='end'>
                        {!!searchValue && (
                          <IconButton
                            onClick={() => {
                              setPaymentsAndMarks({});
                              setSearchValue('');
                              setStudentId('');
                            }}
                          >
                            <CloseIcon></CloseIcon>
                          </IconButton>
                        )}
                      </InputAdornment>
                    ),
                  }}
                  onChange={(e) => setSearchValue(e.target.value)}
                ></TextField>
                <Button
                  variant='contained'
                  disabled={!searchValue}
                  onClick={() => {
                    getStudentCurrentDetails(searchValue);
                    setStudentId(searchValue);
                  }}
                >
                  Search
                </Button>
              </div>
            </Card>
            <Typography variant='h6' className='text-blue-600'>
              {' '}
              Student Details
            </Typography>
            <Card className='p-3 border'>
              <ViewStudent StudentId={studentId} />
            </Card>
            <Typography variant='h6' color='primary' className='mt-3 mb-1'>
              Payments and Marks Details
            </Typography>
            {/* Loading Status for Classes details */}
            {Object.keys(paymentsAndMarks ?? {})?.length == 0 && loading && (
              <Card className='flex items-center justify-center min-h-52 flex-wrap gap-4 my-4 border'>
                <CircularProgress></CircularProgress>
                <Typography variant='body1'>
                  Fectching the Payments and Marks details...
                </Typography>
              </Card>
            )}
            {/*No data message for classes Details*/}
            {Object.keys(paymentsAndMarks ?? {})?.length == 0 && !loading && (
              <Card className='flex items-center justify-center min-h-52  gap-4 mb-4 mt-3 border  '>
                <div className='flex flex-col justify-center items-center h-60  rounded-lg'>
                  <PersonIcon
                    className='text-gray-300 mb-1 animate-pulse'
                    style={{ fontSize: 90 }}
                  />
                  <Typography variant='h6' className='text-gray-400 mb-2'>
                    No Student Selected
                  </Typography>
                  <Typography variant='body2' className='text-gray-500'>
                    Please search by Student Id to know payments and marks
                    details.
                  </Typography>
                </div>
              </Card>
            )}

            {Object.keys(paymentsAndMarks ?? {})?.length > 0 && (
              <Card className='p-4 border'>
                {' '}
                <Typography variant='h6' color='primary' className='mb-2'>
                  Payments
                </Typography>
                {paymentsAndMarks?.payments?.receipts?.length > 0 ? (
                  <>
                    <Typography
                      variant='body1'
                      color='primary'
                      className='mb-1'
                    >
                      Current Payments
                    </Typography>
                    <ReusableMUITable
                      headerNames={[
                        'ReceiptNo',
                        'Payment Type',
                        'Amount',
                        'Accountant',
                      ]}
                      rowValues={[
                        { accessValue: 'receiptNo' },
                        { accessValue: 'paymentType' },
                        {
                          accessValue: 'amount',
                        },
                        {
                          accessValue: 'createdBy',
                          renderCell: (accessKeyName, rowDataObject) => {
                            return (
                              <Tooltip
                                title={rowDataObject?.email ?? 'No email'}
                              >
                                {rowDataObject[accessKeyName]}
                              </Tooltip>
                            );
                          },
                        },
                      ]}
                      dataList={paymentsAndMarks?.payments?.receipts ?? []}
                    />

                    {paymentsAndMarks?.payments?.deletedReceipts?.length >
                      0 && (
                      <>
                        <Typography
                          variant='body1'
                          color='primary'
                          className='mb-1 mt-2'
                        >
                          Deleted Payments
                        </Typography>
                        <ReusableMUITable
                          headerNames={[
                            'ReceiptNo',
                            'Payment Type',
                            'Amount',
                            'Accountant',
                          ]}
                          rowValues={[
                            { accessValue: 'receiptNo' },
                            { accessValue: 'paymentType' },
                            {
                              accessValue: 'amount',
                            },
                            {
                              accessValue: 'createdBy',
                              renderCell: (accessKeyName, rowDataObject) => {
                                return (
                                  <Tooltip
                                    title={rowDataObject?.email ?? 'No email'}
                                  >
                                    {rowDataObject[accessKeyName]}
                                  </Tooltip>
                                );
                              },
                            },
                          ]}
                          dataList={
                            paymentsAndMarks?.payments?.deletedReceipts ?? []
                          }
                        />
                      </>
                    )}
                  </>
                ) : (
                  <Card className='flex items-center justify-center  min-h-44 border'>
                    <Typography>
                      No payment details found for the student
                    </Typography>
                  </Card>
                )}
                <Typography color='primary' variant='h6' className='mt-4'>
                  Marks Table
                </Typography>
                {Object.keys(paymentsAndMarks?.marks ?? {})?.length > 0 ? (
                  Object.keys(paymentsAndMarks?.marks ?? {})?.map(
                    (specificTest, index) => {
                      const specificTestData =
                        paymentsAndMarks?.marks[specificTest];
                      return (
                        <div key={index} className='mt-3'>
                          <div className='flex justify-between items-center  mt-2 mb-1 '>
                            <Typography variant='body1' color='primary'>
                              {Object.keys(paymentsAndMarks?.marks)[index]}
                            </Typography>
                            <Typography className='mr-2'>
                              Status:
                              {checkStatus(specificTestData)}
                            </Typography>
                          </div>
                          <ReusableMUITable
                            headerNames={[
                              'Subject',
                              'Total Marks',
                              'Obtained Marks',
                              'Grade',
                              'Status',
                            ]}
                            rowValues={[
                              { accessValue: 'subject' },
                              { accessValue: 'maxMarks' },
                              { accessValue: 'marks' },
                              { accessValue: 'grade' },
                              { accessValue: 'status' },
                            ]}
                            dataList={
                              paymentsAndMarks?.marks[
                                Object.keys(paymentsAndMarks?.marks)[index]
                              ] ?? []
                            }
                          />
                        </div>
                      );
                    },
                  )
                ) : (
                  <Card className='flex items-center justify-center  min-h-44 border'>
                    <Typography>
                      No marks details found for the Student
                    </Typography>
                  </Card>
                )}
              </Card>
            )}
          </div>
        </Card>
      </Box>
    </>
  );
}
export default StudentFullDetails;
function checkStatus(data = []) {
  const bool = data.every((obj) => obj?.status?.toLowerCase() === 'pass');
  return bool ? (
    <Chip
      icon={<CheckCircle />}
      label='Pass'
      size='small'
      color='success'
      variant='outlined'
    />
  ) : (
    <Chip
      icon={<Cancel />}
      label='Fail'
      size='small'
      color='error'
      variant='outlined'
    />
  );
}
